// Shared/common strings used across the premium overhaul.
const common = {
  en: {
    "common.comingSoon": "Coming soon",
    "common.estimated": "Estimated",
    "common.retry": "Try again",
    "common.somethingWentWrong": "Something went wrong",
    "common.backHome": "Back to home",
    "common.pageNotFound": "Page not found",
    "common.pageNotFoundDesc": "The page you are looking for doesn't exist or has been moved.",
    "common.reloadPage": "Reload page",
    "common.savedJustNow": "Saved just now",
    "common.saving": "Saving…",
    "common.unsavedChanges": "You have unsaved changes. Are you sure you want to leave?",
  },
  tr: {
    "common.comingSoon": "Yakında",
    "common.estimated": "Tahmini",
    "common.retry": "Tekrar dene",
    "common.somethingWentWrong": "Bir şeyler ters gitti",
    "common.backHome": "Ana sayfaya dön",
    "common.pageNotFound": "Sayfa bulunamadı",
    "common.pageNotFoundDesc": "Aradığınız sayfa mevcut değil veya taşınmış.",
    "common.reloadPage": "Sayfayı yenile",
    "common.savedJustNow": "Az önce kaydedildi",
    "common.saving": "Kaydediliyor…",
    "common.unsavedChanges": "Kaydedilmemiş değişiklikleriniz var. Çıkmak istediğinize emin misiniz?",
  },
  es: {
    "common.comingSoon": "Próximamente",
    "common.estimated": "Estimado",
    "common.retry": "Reintentar",
    "common.somethingWentWrong": "Algo salió mal",
    "common.backHome": "Volver al inicio",
    "common.pageNotFound": "Página no encontrada",
    "common.pageNotFoundDesc": "La página que buscas no existe o ha sido movida.",
    "common.reloadPage": "Recargar página",
    "common.savedJustNow": "Guardado ahora",
    "common.saving": "Guardando…",
    "common.unsavedChanges": "Tienes cambios sin guardar. ¿Seguro que quieres salir?",
  },
};

export default common;
